import { mapState, mapActions, mapMutations } from "vuex";
import $ from "jquery";
export const LanguageMixin = {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      lang: state => state.forms.lang,
      translate: state => state.translate.translate,
      nationalities: state => state.forms.nationalities,
      languages: state => state.forms.languages
    })
  },
  methods: {
    ...mapActions({
      getNationality: "forms/getNationality",
      getPageByName: "widgets/getPageByName"
    }),
    ...mapMutations({
      setLang: "forms/SET_LANG",
      setModalContentComputed: "forms/SET_MODAL_CONTENT_COMPUTED"
    }),
    changeLanguage(lang) {
      this.setLang(lang);
      this.makeTranslate(lang);
      this.getNationality(lang).then(() => {
        if ($("#nationality").length > 0) {
          let options =
            "<option selected disabled>" +
            this.translate[this.lang]["choise"] +
            "</option>";

          this.nationalities.forEach(x => {
            options += '<option value="' + x.id + '">' + x.name + "</option>";
          });

          $("#nationality").html(options);
        }
      });
    },
    async setLanguage() {
      await this.getNationality(this.lang).then(() => {
        if ($("#nationality").length > 0) {
          let options =
            "<option selected disabled>" +
            this.translate[this.lang]["choise"] +
            "</option>";

          this.nationalities.forEach(x => {
            options += '<option value="' + x.id + '">' + x.name + "</option>";
          });

          $("#nationality").html(options);
        }
      });
    },
    makeTranslate(lang) {
      let vueThis = this;
      $("input").each(function() {
        let labelID = $(this).attr("id");
        if (vueThis.translate[lang][labelID]) {
          $(this)
            .parent()
            .find("label")
            .html(vueThis.translate[lang][labelID]);
        }
      });
      $("label").each(function() {
        let labelID = $(this).attr("id");
        if (labelID && vueThis.translate[lang][labelID]) {
          $(this).html(vueThis.translate[lang][labelID]);
        }
      });

      $("option").each(function() {
        let labelID = $(this).attr("id");
        if (labelID && vueThis.translate[lang][labelID]) {
          $(this).html(vueThis.translate[lang][labelID]);
        }
      });

      if (document.querySelector("#termsOfClick")) {
        document
          .querySelector("#termsOfClick")
          .addEventListener("click", () => this.getTermsOfModal());
      }
      if (document.querySelector("#privacyClick")) {
        document
          .querySelector("#privacyClick")
          .addEventListener("click", () => this.getPrivacyModal());
      }
    },
    setBrowserLang(lang) {
      let browserLang = navigator.language || navigator.userLanguage;
      if (
        lang === "multi" &&
        Object.keys(this.languages).includes(browserLang)
      ) {
        this.setLang(browserLang);
      }
    },
    async getTermsOfModal() {
      const res = await this.getPageByName({
        slug: "terms-and-conditions",
        lang: this.lang
      });
      this.setModalContentComputed({
        title: res.title,
        description: res.content
      });
      window.$("#computedInfo").modal("show");
    },
    async getPrivacyModal() {
      const res = await this.getPageByName({
        slug: "privacy-policy",
        lang: this.lang
      });
      this.setModalContentComputed({
        title: res.title,
        description: res.content
      });
      window.$("#computedInfo").modal("show");
    }
  }
};
